import React, { useEffect, useState, useMemo } from 'react';
import { getdata, updatedata, formatdate } from "../../util/global";
import AppointmentAdminTable from './AppointmentAdminTable';
import AppointmentAdminForm from './AppointmentAdminForm';

const AppointmentAdmin = () => {
  const [appointmentdata, setappointmentdata] = useState([]);
  const [searchquery, setsearchquery] = useState("");
  const [mode, setmode] = useState("");
  const [formdata, setformdata] = useState({ _id: null, name: "", phonenumber: "", date: "", time: "", status: "", comment: "" });

  const fetchdata = async () => {
    try {
      const data = await getdata({ filter: { datatype: "appointmentdata" } });
      setappointmentdata(data.reverse());
    } catch (err) { console.error(err); }
  };

  const openedit = (item) => {
    const [d, t] = item.datetime.split("T");
    setformdata({ _id: item._id, name: item.name, phonenumber: item.phonenumber,
                  date: d, time: t, status: item.status || "", comment: item.comment || "" });
    setmode("editappointment");
  };

  const handlesubmit = async () => {
    const [yr, mo, dy] = formdata.date.split("-").map(Number);
    const payload = { data: {
      _id: formdata._id,
      datatype: "appointmentdata",
      name: formdata.name,
      phonenumber: formdata.phonenumber,
      date: formdata.date,
      time: formdata.time,
      datetime: formdata.date + "T" + formdata.time,
      datestr: formatdate(new Date(yr, mo - 1, dy)),
      comment: formdata.comment,
    }};
    await updatedata(payload);
    await fetchdata();
    setmode("");
  };

  const handlecancel = async () => {
    await updatedata({ data: { _id: formdata._id, datatype: "appointmentdata", status: "Cancelled" } });
    await fetchdata();
    setmode("");
  };

  useEffect(() => { fetchdata(); }, []);

  const filteredappointments = useMemo(() => {
    return appointmentdata.filter(a =>
      a.name?.toLowerCase().includes(searchquery.toLowerCase()) ||
      a.phonenumber?.toLowerCase().includes(searchquery.toLowerCase())
    );
  }, [appointmentdata, searchquery]);

  return (
    <div className="content-area">
      <div className="table-header-row">
        <div>
          <h1 className="dash-title" style={{ marginBottom: 4 }}>Appointments</h1>
          <p className="muted-sm">Manage all patient appointments</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            placeholder="search name or phone..."
            className="form-input"
            style={{ width: '250px' }}
            value={searchquery}
            onChange={(e) => setsearchquery(e.target.value)}
          />
        </div>
      </div>

      <AppointmentAdminTable data={filteredappointments} openedit={openedit} />
      <AppointmentAdminForm
        mode={mode}
        setmode={setmode}
        formdata={formdata}
        setformdata={setformdata}
        handlesubmit={handlesubmit}
        handlecancel={handlecancel}
      />
    </div>
  );
};

export default AppointmentAdmin;
